var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-container"},[_c('h2',{staticClass:"z-body-small z-body-small--strong"},[_vm._t("title")],2),_c('p',{staticClass:"z-body-small"},[_vm._t("text")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }